import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import brandAPI from "../../api/brandApi";
import BrandCard from "../brands/Card";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Swiper styles import karna mat bhulna
import 'swiper/css';

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");

  useEffect(() => {
    fetchBrand();
  }, []);

  const fetchBrand = async () => {

    try {
      const res = await brandAPI.listing();

      if (res.code === 200) {
        const { brands, totalCount } = res.data;

        setItems(brands);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  return (
    <>

     





      <section className="ith-brand-section section-space">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="ith-section-title-wrapper text-center mb-50">
              <span className="ith-section-subtitle">PARTNERS</span>
              <h2 className="ith-section-title">
                Partners Who Trust Industrial Trading House
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={2}
              loop={true}
              speed={3000} // Smooth continuous effect ke liye
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
              }}
              className="ith-brand-swiper"
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  
                  <div className="ith-brand-item" key={index}>
                  <BrandCard item={item} />
                </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default ListPage;
